import { c as _c } from "react/compiler-runtime";
import { FormSelectMultiple } from '@systemeio/ui';
import { TagInterface } from 'modules/newsletters/single/types/newsletter-interface';
import React from 'react';
import ButtonLikeLink from 'shared/components/button-like-link';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ContactsSettings, ContactsSettingsBlockProps } from '.';
import { CloseIcon } from '@systemeio/ui/icons';
export interface TagsBlockProps extends Pick<ContactsSettingsBlockProps, 'isPreFetching' | 'disabled'> {
  title: string;
  onChangeMultiselect: (value: ContactsSettings['tags']['excluded'] | ContactsSettings['tags']['included']) => void;
  onClickTagLabel: (tagId: TagInterface['id']) => void;
  onSelectAll: () => void;
  onUnselectAll: () => void;
  type?: 'included' | 'excluded';
  tagsList: ContactsSettings['tags']['excluded'] | ContactsSettings['tags']['included'];
  listOfTagsOptions: {
    id: number;
    caption: string;
  }[] | undefined;
  required?: boolean;
}
const TagsBlock = t0 => {
  const $ = _c(38);
  const {
    disabled,
    isPreFetching,
    title,
    required,
    onChangeMultiselect,
    onClickTagLabel,
    onSelectAll,
    onUnselectAll,
    type: t1,
    tagsList,
    listOfTagsOptions
  } = t0;
  const type = t1 === undefined ? "included" : t1;
  const {
    t
  } = useLocoTranslation();
  let t2;
  if ($[0] !== disabled || $[1] !== isPreFetching || $[2] !== listOfTagsOptions || $[3] !== onChangeMultiselect || $[4] !== required || $[5] !== tagsList || $[6] !== title) {
    t2 = <FormSelectMultiple required={required} hideSelectedValues={true} disabled={disabled} isPreFetching={isPreFetching} label={title} data={listOfTagsOptions} value={tagsList} onChange={onChangeMultiselect} />;
    $[0] = disabled;
    $[1] = isPreFetching;
    $[2] = listOfTagsOptions;
    $[3] = onChangeMultiselect;
    $[4] = required;
    $[5] = tagsList;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = disabled || isPreFetching;
  const t4 = `${isPreFetching ? "text-transparent" : ""}}`;
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.contact_email_settings.tags_selector.select_all");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onSelectAll || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <ButtonLikeLink disabled={t3} className={t4} onClick={onSelectAll}>{t5}</ButtonLikeLink>;
    $[10] = onSelectAll;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = disabled || isPreFetching;
  const t8 = `${isPreFetching ? "text-transparent" : ""}}`;
  let t9;
  if ($[15] !== t) {
    t9 = t("dashboard.contact_email_settings.tags_selector.unselect_all");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== onUnselectAll || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <ButtonLikeLink disabled={t7} className={t8} onClick={onUnselectAll}>{t9}</ButtonLikeLink>;
    $[17] = onUnselectAll;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6) {
    t11 = <div className="flex justify-end gap-1">{t6}|{t10}</div>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t2) {
    t12 = <div className="mt-5 flex flex-col gap-1">{t2}{t11}</div>;
    $[25] = t11;
    $[26] = t2;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== disabled || $[29] !== isPreFetching || $[30] !== listOfTagsOptions || $[31] !== onClickTagLabel || $[32] !== tagsList || $[33] !== type) {
    t13 = !isPreFetching && <ul className="mb-5 flex max-h-44 flex-wrap gap-1 overflow-auto pt-1">{tagsList.map(currentId => <li key={currentId} className={`
              text-sm
              ${type === "included" ? "bg-background-primary text-text-primary" : "text-red bg-[#FEF3F2]"}
              main-transition-colors flex h-fit w-fit cursor-default
              items-center gap-1.5 rounded-full
              px-2
              py-1 
            `}>{listOfTagsOptions && (listOfTagsOptions?.find(option => option.id === currentId) || {}).caption}<CloseIcon className={`
                ${!disabled ? "cursor-pointer" : ""}
                ${type === "included" ? "fill-text-primary" : "fill-red"}`} onClick={() => !disabled && onClickTagLabel(currentId)} /></li>)}</ul>;
    $[28] = disabled;
    $[29] = isPreFetching;
    $[30] = listOfTagsOptions;
    $[31] = onClickTagLabel;
    $[32] = tagsList;
    $[33] = type;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13) {
    t14 = <div className="bg-background-secondary flex w-full flex-col overflow-y-hidden rounded-md">{t12}{t13}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
};
export default TagsBlock;